import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SubFooter from '../frontend/components/SubFooter';

function VerificationCompletionPage() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleProceed = () => {
    // ✅ Navigate to Dashboard after successful verification
    navigate('/business-info');
  };

  return (
    <div className="verification-complete-page">
      {/* Header */}
      <header className="header-area header-one">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center py-3">
            <a href="/" className="brand-logo">
              <img src="images/fsl_logo.png" alt="Logo" style={{ height: '50px' }} />
            </a>
            <button 
              className="theme-btn style-two" 
              onClick={() => navigate('/')}
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </header>

      {/* Success Section */}
      <section className="verification-complete-section py-5" style={{ background: '#fafafa', minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8">
              <div className="text-center" data-aos="fade-up">
                {/* Success Icon */}
                <div className="mb-4" data-aos="zoom-in" data-aos-delay="200">
                  <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10" 
                       style={{ 
                         width: '80px', 
                         height: '80px',
                         border: '3px solid #5a4fcf'
                       }}>
                    <i className="fas fa-check text-success" style={{ fontSize: '40px' }}></i>
                  </div>
                </div>

                {/* Title */}
                <h1 className="mb-3" data-aos="fade-up" data-aos-delay="300">
                  Verification Complete!
                </h1>

                {/* Subtitle */}
                <p className="text-muted mb-5" data-aos="fade-up" data-aos-delay="400" style={{ maxWidth: '400px', margin: '0 auto' }}>
                  Your email address has been verified successfully. You're all set to access your dashboard.
                </p>

                {/* Proceed Button */}
                <div className="d-grid gap-3 mx-auto" style={{ maxWidth: '300px' }} data-aos="fade-up" data-aos-delay="500">
                  <button 
                    className="theme-btn style-one btn-lg py-3"
                    onClick={handleProceed}
                    style={{ fontWeight: '600' }}
                  >
                    Proceed <i className="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>

                {/* Show verified user email */}
                {(() => {
                  try {
                    const userData = JSON.parse(localStorage.getItem('signupStep1'));
                    return userData?.email ? (
                      <div className="mt-4" data-aos="fade-up" data-aos-delay="600">
                        <small className="text-muted">
                          Verified email: <strong className="text-dark">{userData.email}</strong>
                        </small>
                      </div>
                    ) : null;
                  } catch (e) {
                    return null;
                  }
                })()}

                {/* Show session info for debugging (optional) */}
                {(() => {
                  try {
                    const sessionData = JSON.parse(localStorage.getItem('signupStep3'));
                    return sessionData?.sessionId ? (
                      <div className="mt-2" data-aos="fade-up" data-aos-delay="700">
                        <small className="text-muted" style={{ fontSize: '11px' }}>
                          Session: {sessionData.sessionId.substring(0, 16)}...
                        </small>
                      </div>
                    ) : null;
                  } catch (e) {
                    return null;
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <SubFooter/>
    </div>
  );
}

export default VerificationCompletionPage;